const ORGANIZATION_ADMIN_LIST_CACHE_ID = 'OrganizationAdminList';

const ORGANIZATION_ADMIN_LIST_EVENT = {
  UPDATE: 'UpdateOrganizationAdminList',
  UPDATE_COUNT: 'UpdateOrganizationAdminCount',
};

export {ORGANIZATION_ADMIN_LIST_CACHE_ID, ORGANIZATION_ADMIN_LIST_EVENT};
